import React from 'react';

import map from 'lodash/map';

import SocialLinkIcon from './social_link_icon.jsx';

import {
  VisuallyHiddenP,
  VisuallyHiddenSpan
} from 'zoomforth_codesbane_viewer/component_lib/visually_hidden.jsx';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const HeaderSocialLinksUi_ViewerVersion1 = ({ socialLinks })=> (
  <div className="social-links-wrapper clearfix">
    <div className="social-links">
      {
        map(socialLinks, (link, index)=> (
            link.enabled &&
              <div
                key={index}
                className={`social-icon-wrapper social-icon-for-${link.serviceName}`}
                data-service-name={link.serviceName}
              >
                <a
                  href={`${link.link}`} 
                  target={link.target || '_blank'}
                  className="social-icon-link"
                >
                  <SocialLinkIcon serviceName={link.serviceName} />
                </a>
              </div>
          )
        )
      }  
    </div>
  </div>
);

const HeaderSocialLinksUi_ViewerVersion2 = ({ socialLinks })=> (
  <nav aria-labelledby="socialNavLabel" className="social-links-wrapper clearfix">
    <VisuallyHiddenP id="socialNavLabel">
      Social
    </VisuallyHiddenP >

    <div className="social-links">
      {
        map(socialLinks, (link, index)=> (
            link.enabled &&
              <div
                key={index}
                className={`social-icon-wrapper social-icon-for-${link.serviceName}`}
                data-service-name={link.serviceName}
              >
                <a
                  href={`${link.link}`} 
                  target={link.target || '_blank'}
                  className="social-icon-link zf-external-link"
                >
                  <SocialLinkIcon serviceName={link.serviceName} />
                  <VisuallyHiddenSpan>
                    { link.serviceName }
                  </VisuallyHiddenSpan>
                  <span className="opens-in-external-view-wrapper">
                    Opens in a new window
                  </span>
                </a>
              </div>
          )
        )
      }  
    </div>
  </nav>
);

const HeaderSocialLinksUi = (props)=> (
  <SiteViewerVersionComponentSelector>
    <HeaderSocialLinksUi_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <HeaderSocialLinksUi_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default HeaderSocialLinksUi;
